var exports = {
  "kL": "Notifications.module__container___UW5CWF",
  "Wq": "Notifications.module__switchesContainer___UW5CWF",
  "_8": "Notifications.module__pushSection___UW5CWF",
  "Fm": "Notifications.module__pushHeading___UW5CWF",
  "p2": "Notifications.module__pushDescription___UW5CWF",
  "_j": "Notifications.module__pushButtons___UW5CWF",
  "zd": "Notifications.module__pushButton___UW5CWF",
  "Zo": "Notifications.module__pushButtonSecondary___UW5CWF",
  "pz": "Notifications.module__pushStatus___UW5CWF",
  "$r": "Notifications.module__pushList___UW5CWF",
  "MW": "Notifications.module__pushListItem___UW5CWF",
};

module.exports = exports;
